import { debug } from 'settings/custom/build'

export default class ErrorListener {
  constructor() {
    this.errorContainer = null
  }
  startListening() {
    window.onerror = (arg1, arg2, arg3, arg4, error) => {
      this.showError(error)
    }
    window.addEventListener('unhandledrejection', (event) => {
      this.showError(`${event.reason.message} ${event.reason.stack}`)
    })
  }
  showError(error) {
    if (!this.errorContainer && debug) {
      this.createErrorContainer()
      this.errorContainer.errorText.text = `Error: ${error}`
    }
  }

  createErrorContainer() {
    this.app = new PIXI.Application()
    document.body.appendChild(this.app.view)

    this.stage = new PIXI.Container()
    this.app.stage.addChild(this.stage)

    this.errorText = new PIXI.Text('', { fill: 'red' })
    this.errorText.position.set(10, 10)
    this.stage.addChild(this.errorText)

    this.errorContainer = {
      app: this.app,
      stage: this.stage,
      errorText: this.errorText,
    }
  }
}
